import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import imgProfile from "../images/profile.jpg";

export default function IntroCard() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "center",
        alignContent: "center",
        pt: { xs: theme.spacing(5), md: theme.spacing(10) },
        pb: { xs: theme.spacing(5), md: theme.spacing(10) },
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width={{ xs: "85%", md: "70%" }}
        flexDirection={{ xs: "column", md: "row" }}
        sx={{
          backgroundColor: "rgba(244,242,238,1)",
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          pt={theme.spacing(5)}
          mb={{ xs: 0, md: theme.spacing(-5) }}
          width={{ xs: "100%", md: "50%" }}
          sx={{
            opacity: 0.9,
          }}
        >
          <img width="70%" height="auto" src={imgProfile} alt="profile"></img>
        </Box>
        <Box
          pt={theme.spacing(5)}
          pb={theme.spacing(3)}
          width={{ xs: "80%", md: "50%" }}
        >
          <Box
            width="90%"
            height="100%"
            sx={{
              fontSize: { xs: "0.8rem", md: "0.9rem" },
            }}
          >
            <Typography variant="h3" fontStyle="italic">
              Behind the lens
            </Typography>
            <Typography variant="h5" fontWeight={550}>
              About CK
            </Typography>
            <p>
              I am a wedding and portrait photographer currently based in the
              Netherlands and available throughout Europe.
            </p>
            <p>
              I started my photography journey in 2006 and love nature and
              landscape photography. As time unfolded, wedding and portrait
              photography also became one of my favorite subjects. My strength
              of uncovering captivating scenes and recognizing the nuances of
              natural light enables me to craft images that resonate with your
              unique style and aspirations, preserving timeless memories.
            </p>
            <p>
              Through my photography, I aim to tell stories of candid emotions
              and lasting moments with bright and poetic colors. If you're
              intrigued and wish to delve deeper into the world of my
              photography, don't hesitate to reach out. Feel free to send me a
              message at <i>ck.pxgallery@gmail.com</i> for more information
              about my services.
            </p>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
